import { appendHelpers } from '../helpers/helpers_manager'
import { formatDate } from '@/utils/date_manipulation'

const moduleName = '.search'

const ARRAY_FIELDS = [
  'brands', 'collection_years', 'event_years', 'collaboration_years', 'lines', 'seasons',
  'collections', 'family_people', 'celebrities', 'iso_codes', 'magazines', 'newspapers',
  'websites', 'socials'
]

const searchFilters = (filters) => {
  let parsedFilter = {}

  Object.keys(filters).forEach(key => {
    let filter = filters[key]
    
    parsedFilter[key] = Array.isArray(filter) ? filter.join(',') : filter
    
    if(key.match(/(start|end)_date/) && filter) 
      parsedFilter[key] = formatDate({ date: filter })

    if(parsedFilter[key] === true && ARRAY_FIELDS.includes(key)) delete parsedFilter[key]
    
    if(String(parsedFilter[key]).trim() === '') delete parsedFilter[key]
  })

  return parsedFilter
}

export default ({
  repository,
  clientWrapper,
  context
}) => ({
  search: (filters) => {
    context.lastApiPath = `${moduleName}.search`

    const internalFilters = searchFilters(filters)

    return clientWrapper.api
      .get('/resources/search', { params: {...internalFilters } })
      .then(({ data, meta }) => {
        const response = data.map(pub => appendHelpers(pub.attributes, repository, ['issue', 'images', 'rects']))
        return { response, total: meta.total }
      })
  },

  searchGeo: (filters) => {
    context.lastApiPath = `${moduleName}.searchGeo`

    const internalFilters = searchFilters(filters)

    return clientWrapper.api
      .get('/resources/search/geo.json', { params: {...internalFilters } })
      .then(data => ({ response: data, total: null }))
  },

  searchManualInput: (filters = {}) => {
    context.lastApiPath = `${moduleName}.searchManualInput`

    const internalFilters = searchFilters(filters)

    return clientWrapper.api
      .get('resources/search/manual', { params: { ...internalFilters } })
      .then(({ data, meta }) => {
        const response = data.map(pub => appendHelpers(pub.attributes, repository, ['issue', 'images', 'rects']))
        return { data: response, total: meta.total }
      })
  }
})